<template>
  <div class="key_visual addImg con">
    <div class="container">
      <p>콘텐츠</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentsTitle',
}
</script>
